import { stringifyRichText } from './stringifyRichText';
export function isEmpty(value) {
    if (!value)
        return true;
    return stringifyRichText(value).trim() === '';
}
